import React, { FC } from 'react';
import ScrollableAnchor from 'react-scrollable-anchor';
import { Grid } from '../../UIKit/system';
import Title from '../../title';
import Shapes from '../../section-tabs/shapes';
import Container from '../../container';

interface ProductSizeGuideProps {
  items?: {
    columnOneName: string;
    columnTwoName: string;
    columnThreeName: string;
    columnFourName: string;
    columnFiveName: string;
    tableData: {
      _uid: string;
      area: string;
      columnFive: string;
      component: string;
      height: string;
      type: string;
      width: string;
    }[];
  }[];
}

export const ProductSizeGuide: FC<ProductSizeGuideProps> = (props) => {
  const { items } = props;

  if (!items || items.length === 0) return null;

  return (
    <ScrollableAnchor id="size-guide">
      <Grid>
        <Container large my={[48, 96]}>
          <Grid>
            <Title as="h2" fontSizeSmall>
              Size Guide
            </Title>
            <Shapes items={items} scrollable />
          </Grid>
        </Container>
      </Grid>
    </ScrollableAnchor>
  );
};
